import { useNavigate, useParams } from 'react-router-dom';
import './adminAssessment.css';
import { useEffect, useState } from 'react';
import connector from '../../connector/connector';
import Footer from '../../components/footer/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheckCircle, faInfoCircle, faStar } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import utilities from '../../utils/utils';
import { color } from 'd3';
import AdminHeader from '../../components/adminHeader/adminHeader';
import BannerImage from '../../components/bannerImage/bannerImage';
import ScoreTrendIndicator from '../../components/scoreTrendIndicator/scoreTrendIndicator';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

moment().format();







const AdminAssessment = () => {





    const navigate = useNavigate();

    if (!localStorage.getItem('adminTokenTime') || utilities.isdateOlderThan30Minutes(localStorage.getItem('adminTokenTime'))) {
        navigate('/admin');
    }


    let subtitle;
    const [modalIsOpen, setIsOpen] = useState(false);

    function openModal() {
        setIsOpen(true);
        const fetchedCountries = connector.fetchCountries().then((countries) => {
            console.log('countries', countries);
            setCountryOptions(countries);
        });
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        setDoneAddingGeoInfo(false);
    }

    function closeModal() {
        setIsOpen(false);
    }


    const assessmentId = useParams().id;


    const [showTitle, setShowTitle] = useState(true);
    const [assessmentData, setAssessmentData] = useState({});
    const [assessmentDataCopy, setAssessmentDataCopy] = useState({});
    const [isEmailDisposable, setIsEmailDisposable] = useState(true);
    const [geoCity, setGeoCity] = useState('');
    const [geoState, setGeoState] = useState('');
    const [geoCountry, setGeoCountry] = useState('');
    const [countryOptions, setCountryOptions] = useState([]);
    const [doneAddingGeoInfo, setDoneAddingGeoInfo] = useState(false);



    useEffect(() => {
        connector.fetchSingleAssessmentData(assessmentId).then((data) => {
            console.log('single assessment data', data);
            setAssessmentData(data);
            setAssessmentDataCopy(data);

            console.log('assessmentData', data);
            console.log('assessmentDataCopy', assessmentDataCopy);
            console.log('broser info', utilities.getBrowserInfo());
        });
    }, [assessmentId]);

    useEffect(() => {
        if (assessmentData.email) {
            connector.isEmailDisposable(assessmentData.email).then((isDisposable) => {
                setIsEmailDisposable(isDisposable.disposable);
                console.log('isEmailDisposable', isDisposable);
            });
        }
    }, [assessmentData.email]);

    const markAsWeighted = async () => {
        try {
          // 1. Mark assessment as weighted
          const reviewDate = new Date();
      
          const res = await connector.updateAssessmentFields(assessmentId, {
            Weighted: 'true',
            'Review Date': reviewDate,
            Reviewed: 'true',
          });
      
          console.log('front-end', res);
      
          setAssessmentData(prev => ({
            ...prev,
            weighted: 'true',
            reviewDate,
            reviewed: 'true',
          }));
      
          // 2. Calculate + update topic scores
          
          // 3. Add geo info
          await connector.updateAssessmentFields(assessmentId, {
            City: geoCity,
            'State/Territory': geoState,
            'Country Code': geoCountry,
          });
      
          setDoneAddingGeoInfo(true);
      
          setTimeout(closeModal, 3000);
        } catch (err) {
          console.error('Failed to mark assessment as weighted:', err);
          // optional: show toast / UI error state here
        }
      };
      

      const markAsUnweighted = async () => {
        try {
          const reviewDate = new Date();
      
          const res = await connector.updateAssessmentFields(assessmentId, {
            Weighted: 'false',
            'Review Date': reviewDate,
            Reviewed: 'true',
          });
      
          console.log('front-end', res);
      
          setAssessmentData(prev => ({
            ...prev,
            weighted: 'false',
            reviewDate,
            reviewed: 'true',
          }));
        } catch (err) {
          console.error('Failed to mark assessment as unweighted:', err);
        }
      };
      

    const markAsReviewed = async () => {
        const updateResults = await connector.updateAssessmentFields(assessmentId, {
            Reviewed: 'true',
            'Review Date': new Date()
        }).then((res) => {
            setAssessmentData({
                ...assessmentData,
                weighted: 'false',
                reviewDate: new Date(),
                reviewed: 'true'
            })
        })
        console.log('front-end', updateResults)
    }

    const handlefilterChange = (e) => {
        console.log('filterChange', e.target);
        let filterValue = e.target.value;
        // console.log('filterValue', filterValue);
        if (filterValue === 'all') {
            setAssessmentData({
                ...assessmentData,
                responses: assessmentDataCopy.responses
            });
            return;
        }
        setAssessmentData({
            ...assessmentData,
            responses: assessmentDataCopy.responses.filter((response) => {
                return response.category === filterValue;
            })
        });
    };

    const searchAssessmentDataResponses = (searchTerm) => {
        if (searchTerm === '') {
            setAssessmentData({
                ...assessmentData,
                responses: assessmentDataCopy.responses
            });
            return;
        }
        setAssessmentData({
            ...assessmentData,
            responses: assessmentDataCopy.responses.filter((response) => {
                return response.question && response.question.toLowerCase().includes(searchTerm.toLowerCase());
            })
        });
    };



    return (
        <div className="admin-assessment">
            <AdminHeader></AdminHeader>
            <BannerImage text={`Assessment`}></BannerImage>
            <h1 onClick={() => setShowTitle(!showTitle)} className={assessmentData.weighted === "true" ? 'weighted' : 'unweighted'}>{showTitle ? 'Assessment' : assessmentId}{assessmentData.weighted === "true" ? <p className='counted-text-pill'>counted</p> : <></>}{assessmentData.caic ? <span title='City AI Connect Partner' className='gold-star'><FontAwesomeIcon icon={faStar}></FontAwesomeIcon></span> : <></>}</h1>
            {assessmentData.email && <details><summary>Contact Information</summary>
                <table>
                    <tbody>
                        <tr>
                            <td>Email:</td>
                            <td>{assessmentData.email}<span className='valid-email' title='This email is not a disposable email address'>{!isEmailDisposable && <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>}</span></td>
                        </tr>
                    </tbody>
                </table>
            </details>}
            {assessmentData && <><details><summary>Assessment Details </summary>
                <table>
                    <tbody>

                        <tr>
                            <td>Time Submitted</td>
                            <td>{`${moment(assessmentData.submissionTime).format("MMMM Do YYYY, h:mm:ss A")} | (${moment(assessmentData.submissionTime).fromNow()})`}</td>
                        </tr>
                        <tr>
                            <td>Source</td>
                            <td>{assessmentData.source}</td>
                        </tr>
                        <tr>
                            <td>Browser</td>
                            <td>{`${assessmentData.browser} (${assessmentData.browserVersion})`}</td>
                        </tr>
                        <tr>
                            <td>Device Type</td>
                            <td>{assessmentData.deviceType}</td>
                        </tr>
                        <tr>
                            <td>Average time between questions</td>
                            <td>{utilities.averageTimeBetweenResponses(assessmentData.responses)}</td>
                        </tr>
                        <tr>
                            <td>Total time between responses</td>
                            <td>{utilities.totalTimeBetweenResponses(assessmentData.responses)}</td>
                        </tr>
                        <tr>
                            <td>Points Awarded</td>
                            <td>{utilities.countTotalPoints(assessmentData.responses)}</td>
                        </tr>

                        {
                            assessmentData.responses && assessmentData.responses.filter(val => val.answers.length > 0 && val.category != 'Opportunities').length > 0 && <tr>
                                <td>Qualified Responses</td>
                                <td>{assessmentData.responses && assessmentData.responses.filter(val => val.answers.length > 0 && val.category != 'Opportunities').length}</td>
                            </tr>
                        }


                    </tbody>
                </table>
            </details>
                <details><summary>Assessment Responses <span className='assessment-count-span'>{assessmentData.responses && assessmentData.responses.length}</span></summary>
                    <ul className='admin-responses-btn-list'>
                        <li>
                            <button value="all" onClick={handlefilterChange}>All</button>
                        </li>
                        <li>
                            <button onClick={handlefilterChange} value="Policy" style={{ backgroundColor: '#E04B43', color: 'white' }}>Policy</button>
                        </li>
                        <li>
                            <button value="People" onClick={handlefilterChange} style={{ backgroundColor: '#5762DE', color: 'white' }}>People</button>
                        </li>
                        <li>
                            <button value="Technology" onClick={handlefilterChange} style={{ backgroundColor: '#E3A83D', color: 'white' }}>Technology</button>
                        </li>
                        <li>
                            <button value="Opportunities" onClick={handlefilterChange} style={{ backgroundColor: '#64DEA6', color: 'white' }}>Opportunities</button>
                        </li>
                    </ul>

                    <input className='admin-assessment-question-search' type='text' placeholder='Search for a question/option' onKeyDown={(e) => { searchAssessmentDataResponses(e.target.value) }}></input>

                    {assessmentData.responses && assessmentData.responses.map((response, index) => (
                        <div key={index} className='response-block'>
                            <h3 className='response-question'> {response.question && response.question.split('|')[0]} <span className={`${response.category}-list-pill`}>{response.category}</span>{response.category !== "Opportunities" && <span>{response.answers.reduce((sum, item) => sum + item.points, 0) + ' pts'}</span>}</h3>

                            <ul>
                                {response.answers.map((ans, idx) => (

                                    <li key={idx} ><p className={ans.points === 0 ? 'no-points-option' : 'points-option'} title={ans.points}>{ans.label}</p></li>

                                ))}
                            </ul>
                            {/* {response.followUpAnswers && response.followUpAnswers.length > 0 && (
                            <div className='follow-up-answers'>
                                <h4>Follow-Up Answers:</h4>
                                <ul>
                                    {response.followUpAnswers.map((followUp, idx) => (
                                        <li key={idx}>{followUp}</li>
                                    ))}
                                </ul>
                            </div>
                        )} */}
                            {response.followUp && <p className='response-followup'><span><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon></span>{response.followUp}</p>}
                            <p className='response-followup'><span><FontAwesomeIcon icon={faCalendar}></FontAwesomeIcon></span>{moment(response.timeStamp).format("MMMM Do YYYY, h:mm:ss A")}</p>
                        </div>
                    ))}
                </details>
                {
                    assessmentDataCopy.relatedAssessments && assessmentData.relatedAssessments.length > 0 && <details><summary>Related Assessments <span className='assessment-count-span'>{assessmentData.relatedAssessments.length}</span></summary>
                        <ul className='related-assessments-list'>
                            {assessmentData.relatedAssessments.map((relatedAssment, idx) => (
                                <li key={idx} onClick={() => navigate(`/admin/gradebook/assessment/${relatedAssment.id}`)} className='related-assessments-list-item'>

                                    <p className='related-assessment-link'>{` ID: ${relatedAssment.id} `}</p>
                                    <p>{`Date Submitted ${moment(relatedAssment.createdTime).format("MMMM Do YYYY, h:mm:ss A")} (${moment(relatedAssment.createdTime).fromNow()})`}</p>
                                    <p>Total Score: {relatedAssment.fields['Total Score']}</p>
                                    {/* <p>{utilities.calculateTrend(relatedAssment.totalScore, assessmentData.totalScore).trend}</p> */}
                                    <p>{`${relatedAssment.fields.responses.length} responses`}</p>
                                    <p>{console.log(assessmentData.fields, relatedAssment.fields)}</p>
                                    <ScoreTrendIndicator currentAssessmentData={assessmentData} previousAssessmentData={relatedAssment}></ScoreTrendIndicator>
                                </li>
                            ))}
                        </ul>
                    </details   >
                }
                {
                    Object.keys(assessmentData).length > 0 && <div className='admin-assessment-buttons-wrapper'>
                        {assessmentData.reviewed === "true" && <p>{`This assessment was reviewed on ${moment(assessmentData.reviewDate).format("MMMM Do YYYY, h:mm:ss A")} (${moment(assessmentData.reviewDate).fromNow()})`}</p>}
                        {assessmentData.reviewed !== "true" && <button className='mark-reviewed-button' onClick={markAsReviewed}>Mark as Reviewed</button>}
                        {assessmentData.weighted === "true" ? <button className='mark-weighted-button' onClick={markAsUnweighted}>Mark as Uncounted</button> : <button onClick={openModal}>Mark as Counted</button>}
                    </div>

                }
            </>}
            {/* <Footer></Footer> */}


            <Modal
                isOpen={modalIsOpen}
                // onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='geo-info-modal'>
                    {/* <button onClick={closeModal}>close</button> */}
                    <h2>Please input city's geographical information</h2>


                    <form className='city-info-form'>
                        <input type='text' placeholder='City' value={geoCity} onChange={(e) => { setGeoCity(e.target.value) }} /><br></br>
                        <input type='text' placeholder='State/Territory' value={geoState} onChange={(e) => { setGeoState(e.target.value) }} /><br></br>
                        <select value={geoCountry} onChange={(e) => {
                            setGeoCountry(e.target.value);
                        }}>
                            <option >Select Country</option>
                            {countryOptions.map((country, index) => (
                                <option key={index} value={country}>{country}</option>
                            ))}
                        </select><br></br>
                        <button onClick={markAsWeighted}>{doneAddingGeoInfo ? 'Done!' : 'Submit'}</button>
                    </form>
                </div>
            </Modal>

        </div>
    );
};

export default AdminAssessment; 